var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-secondary","icon-left":"broom","size":"is-small"},on:{"click":_vm.handleClear}},[_vm._t("default",function(){return [_vm._v("Limpiar")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }